import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="empty-state">
      <p className="page-hero__eyebrow">404</p>
      <h1>Page not found</h1>
      <p>The route does not exist in this starter yet.</p>
      <Link className="button button--primary" to="/">
        Return home
      </Link>
    </div>
  );
}
